import { useEffect, useState } from 'react'

export const useDarkMode = () => {
  const [isSystemDarkMode, setIsSystemDarkMode] = useState(false)
  const [isForcedDarkMode, setIsForcedDarkMode] = useState(false)

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
    setIsSystemDarkMode(mediaQuery.matches)

    const handleChange = (e) => {
      setIsSystemDarkMode(e.matches)
      detectForcedDarkMode()
    }

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange)
    } else {
      mediaQuery.addListener(handleChange)
    }

    const detectForcedDarkMode = () => {
      const el = document.createElement('div')
      el.style.background = 'Canvas'
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)

      const bg = getComputedStyle(el).backgroundColor
      document.body.removeChild(el)

      const rgb = bg.match(/\d+/g)?.map(Number) || [255, 255, 255]
      const brightness = rgb[0] * 0.299 + rgb[1] * 0.587 + rgb[2] * 0.114

      setIsForcedDarkMode(brightness < 128)
    }

    detectForcedDarkMode()

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange)
      } else {
        mediaQuery.removeListener(handleChange)
      }
    }
  }, [])

  const isDarkMode = isSystemDarkMode || isForcedDarkMode

  return { isDarkMode, isSystemDarkMode, isForcedDarkMode }
}
